import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { SERVICE_SECTIONS, IMAGES } from "../data/content";
import Reveal from "../components/Reveal";
import Seo, { SERVICE_CATALOG_LD, LOCAL_BUSINESS_LD } from "../components/Seo";

export default function Services() {
  return (
    <div data-testid="page-services">
      <Seo
        title="Services — Consulting, Marketing, Web, Branding & Operations"
        description="Business consulting, digital marketing, website design, social media, operations consulting, branding, and government proposal support for Dallas–Fort Worth businesses."
        path="/services"
        jsonLd={{ "@context": "https://schema.org", "@graph": [LOCAL_BUSINESS_LD, SERVICE_CATALOG_LD] }}
      />
      <section className="bg-white pt-20 pb-10">
        <div className="container-wide max-w-4xl">
          <div className="overline mb-6">Services</div>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]" data-testid="services-page-headline">
            Coordinated services designed to move your business forward.
          </h1>
          <p className="mt-6 text-lg text-[#4B5563] leading-relaxed">
            From strategy to daily operations, we help business owners plan, build, and improve the things that matter most.
          </p>
        </div>
      </section>

      <section className="bg-[#F7F7F8]">
        <div className="container-wide py-16 md:py-24 space-y-16">
          {SERVICE_SECTIONS.map((sec, i) => (
            <Reveal key={sec.slug}>
              <div id={sec.slug} className="bg-white p-8 md:p-12 border border-gray-100 grid md:grid-cols-12 gap-8 scroll-mt-28" data-testid={`service-section-${sec.slug}`}>
                <div className="md:col-span-4">
                  <div className="overline mb-3">0{i + 1}</div>
                  <h2 className="font-serif text-2xl md:text-3xl tracking-tight leading-tight">{sec.title}</h2>
                  <p className="mt-4 text-sm text-[#4B5563] leading-relaxed">{sec.lead}</p>
                  <Link to="/growth-assessment" className="btn btn-ghost mt-6" data-testid={`service-cta-${sec.slug}`}>
                    Request a Custom Quote <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
                  </Link>
                </div>
                <div className="md:col-span-8">
                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3 text-sm">
                    {sec.items.map((it) => (
                      <li key={it} className="flex gap-2 items-start"><Check className="w-4 h-4 mt-1 text-gold shrink-0" strokeWidth={2} />{it}</li>
                    ))}
                  </ul>
                  {sec.disclaimer && <p className="mt-6 text-xs text-[#6B7280] italic">{sec.disclaimer}</p>}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-[#0A0A0A] text-white">
        <div className="container-wide py-20 text-center max-w-3xl mx-auto">
          <h2 className="font-serif text-3xl sm:text-4xl">Let's design the right engagement for your business.</h2>
          <div className="mt-8 flex gap-4 justify-center flex-wrap">
            <Link to="/growth-assessment" className="btn btn-primary" data-testid="services-final-cta">Get Your Free Growth Assessment</Link>
            <Link to="/contact" className="btn btn-dark">Let's Talk About Your Business</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
